module.exports = __webpack_public_path__ + "static/media/hospital-week-4.06c35d4a.jpg";